<i18n>
{
  "de": {
    "unlockContent": "Inhalt freischalten"
  },
  "en": {
    "unlockContent": "Unlock content"
  }
}
</i18n>

<template>
  <div>
    <button
      class="button is-primary is-flex purchase-button is-small"
      @click="$router.push(
        localePath({
          name: 'id-post-slug-postId',
          params: {
            id: artist.urlAlias,
            postId: post._id,
            slug: urlSlug(post.title),
            title: `${artist.nickname} - ${post.title}`
          }
        })
      )"
    >
      <bag-icon />
      <span>{{ $t('unlockContent') }}</span>
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import bagIcon from '~/components/bag-icon'

export default {
  name: 'post-purchase-btn',
  props: ['post'],
  components: { bagIcon },
  data: () => ({
  }),
  computed: {
    ...mapState(['artist'])
  }
}
</script>

<style lang="scss">
button.purchase-button {
  padding: 0.9rem;
  padding-left: 0.4rem;

  &:hover {
    .bag {
      transform: scale(1.1);
    }
  }
}

.min-width {
  min-width: 200px;
}
</style>
